import classnames from 'classnames';
import { CompositeTextInput } from '@leverege/ui-elements';
import { FilterSourcesModel, FilterSourceModel } from '@leverege/molten/filters';
import { useCallback, useMemo, useState } from 'react';
import S from './SearchBar.css';
import RsrcFilterModel from "../../filter/RsrcFilterModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SearchBar({
  filters,
  onFilterChange
}) {
  const filter = useMemo(() => {
    return FilterSourcesModel.getSource(filters, 'filterBar') || FilterSourceModel.create();
  }, [filters]);
  const rsrcFilterModel = useMemo(() => {
    return FilterSourceModel.getMetadata(filter)?.filter || RsrcFilterModel.create();
  }, [filter]);
  const value = useMemo(() => {
    return RsrcFilterModel.getFilter(rsrcFilterModel, 'path');
  }, [rsrcFilterModel]);
  const [sValue, setSValue] = useState(value);
  const onChange = useCallback(evt => {
    setSValue(evt.value);
  }, []);
  const onKeyUp = useCallback(evt => {
    if (evt.keyCode === 13 || evt.data === 'search') {
      const nRsrcFilterModel = RsrcFilterModel.setFilter(rsrcFilterModel, 'path', sValue);
      let nFilter = FilterSourceModel.setMetadata(filter, {
        filter: nRsrcFilterModel
      });
      nFilter = FilterSourceModel.setFilter(nFilter, RsrcFilterModel.toRsrcFilter(nRsrcFilterModel));
      onFilterChange({
        data: 'filterBar',
        value: nFilter
      });
    }
  }, [sValue, rsrcFilterModel, filter, onFilterChange]);
  return /*#__PURE__*/_jsx(CompositeTextInput, {
    className: classnames(S.pathFilter, S.more, S.specific),
    variant: "search",
    button: "Filter",
    hint: "Filter By Parent Path",
    value: sValue,
    onChange: onChange,
    onKeyUp: onKeyUp,
    buttonProps: {
      eventData: 'search',
      onClick: onKeyUp
    }
  });
}